/*
    表格区展开卡片区域组件
    created by: liyaoh 2019-05-27
*/
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { connect } from "react-redux";


const areaTarget = {
    drop(props, monitor, component){
        const dragItem = monitor.getItem();
        //从左侧拖拽非元数据
        if (dragItem.type === 'card') {
            props.onDrop(monitor);
        }
    }
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
}))
class TableFoldArea extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {
            fold,
            isActive,
            renderCard,
            visible,
            onClick,
            renderHeader,
            connectDropTarget,
            areaHide
        } = this.props;
        let listWithBlank = [
            ...fold.queryPropertyList,
            { blank: true, areaid: fold.pk_area, code: 'blank' }
        ];
        return !areaHide[fold.pk_area] && connectDropTarget(
            <div
                className={`form-area-group ${isActive ? 'active' : ''}`}
                style={{ display: visible ? "block" : "none" }}
                onClick={onClick}
            >
                {renderHeader}
                <div className="form-area-content" fieldid="content">
                    {listWithBlank.map(renderCard)}
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        areaHide: state.zoneSettingData.areaHide,
    })
)(TableFoldArea);
